// src/pages/PrivacyPolicy.tsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { POLICY_VERSION } from '../lib/policy';

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  const handleBack = () => {
    // אם יש היסטוריה פנימית באפליקציה נחזור אחורה, אחרת נחזור ל-/login
    const hasSpaHistory = !!(window.history?.state && (window.history.state as any).idx > 0);
    if (hasSpaHistory) {
      navigate(-1);
    } else {
      navigate('/login');
    }
  };

  useEffect(() => {
    const onEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') handleBack();
    };
    window.addEventListener('keydown', onEsc);
    return () => window.removeEventListener('keydown', onEsc);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-[100dvh] bg-white">
      {/* בר עליון עם חזרה */}
      <div className="sticky top-0 z-10 border-b bg-white/80 backdrop-blur">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center justify-between">
          <button
            onClick={handleBack}
            className="inline-flex items-center gap-2 text-sm text-indigo-600 hover:text-indigo-700 active:scale-[0.99] transition-all"
            aria-label="חזרה"
          >
            <ArrowRight className="h-5 w-5" />
            חזרה
          </button>
          {/* <span className="text-[11px] text-gray-500">גרסה: {POLICY_VERSION}</span> */}
        </div>
      </div>

      {/* תוכן המדיניות */}
      <div className="max-w-3xl mx-auto px-4 py-8">
        <h1 className="text-2xl sm:text-3xl font-bold mb-2 text-center">מדיניות פרטיות – LoyalFlow</h1>
        <p className="text-sm text-gray-500 mb-8 text-center">
          עודכן: 12.10.2025 | גרסה: {POLICY_VERSION}
        </p>

        <div className="prose prose-sm sm:prose-base max-w-none">
          <p>
            ברוך/ה הבא/ה ל-LoyalFlow. המדיניות שלהלן מסבירה כיצד אנו אוספים, משתמשים, שומרים ומשתפים מידע שמתקבל בעת שימושך בשירות.
          </p>

          <h2>איזה מידע אנו אוספים</h2>
          <ul>
            <li>פרטי חשבון (אימייל, שם, מזהה משתמש)</li>
            <li>נתוני שימוש במערכת (לוגים, פעולות, ועוד)</li>
            <li>מידע הנדרש לצורכי סליקה/חשבוניות (בהתאם לחוק)</li>
          </ul>

          <h2>למה אנו משתמשים במידע</h2>
          <p>מתן השירות, אבטחה, שיפור חוויית משתמש, עמידה בדרישות חוק וכו׳.</p>

          <h2>שיתוף מידע</h2>
          <p>ספקי משנה (למשל תשלומים), בהתאם להסכמים ולחוק. לא נמכור נתונים לצד ג׳.</p>

          <h2>אבטחת מידע</h2>
          <p>נוקטים באמצעים סבירים (טכנולוגיים וארגוניים) לשמירת המידע.</p>

          <h2>זכויות משתמש</h2>
          <p>זכות לעיון/מחיקה/תיקון בהתאם לחוק. לפניות: support@loyalflow.co.il</p>

          <h2>שינויים במדיניות</h2>
          <p>נעדכן גרסה ונציג הודעה. המשך שימוש משמעו הסכמה לגרסה המעודכנת.</p>
        </div>

        {/* כפתור חזרה גם בתחתית למסכים ארוכים */}
        <div className="mt-10 flex justify-center">
          <button
            onClick={handleBack}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-xl border border-gray-200 text-sm text-gray-700 hover:bg-gray-50 active:scale-[0.99] transition-all"
          >
            <ArrowRight className="h-5 w-5" />
            חזרה
          </button>
        </div>
      </div>
    </div>
  );
}
